import { gql } from 'apollo-boost';

export const PUBLISH_FOLDER = gql`
    mutation publishFolder($data: PublishFolderInput!) {
        publishFolder(data: $data) {
            token
            url
            discoverable
            linkRole
            allowAnonymousContributions
            allowCopy
            viewCount
            createdAt
        }
    }
`;
